<template>
	<div class="class">
		<teacherHeader :logo_name="logo_name" @info-event="myInfoEvent" @public-event="publicEvent"></teacherHeader>
		<div class="task_cont bg_blue">
			<div class="task_cont_div bg_white radius8 bs">
				<div class="task_cont_nav f18px cl_dark">
					<router-link :to="item.url" class="task_cont_nav_list" v-for="(item,index) in nav" :key="index" :class="{'on': item.id == nav_cur}">{{item.name}}</router-link>
				</div>
				<div class="task_subject cl_gray tc">
					<span class="task_subject_list bg_gray cur" v-for="(item,index) in subject" :key="index"
					 @click="subjectCheck(item.subjectName)" :class="{'on': subject_cur == item.subjectName}">{{item.subjectName}}</span>
				</div>
				<div class="task_paper_screen mat30">
					<div class="test_screen cl_gray">
						<div class="test_screen_l f16px"><span class="inline">年级</span><i class="inline">：</i></div>
						<div class="test_screen_r tc">
							<span class="test_screen_list bg_gray" v-for="(item,index) in grade" :key="index" :class="{'on':item==grade_cur}" @click="gradeCheck(item)">{{item}}</span>
						</div>
					</div>
					<div class="test_screen cl_gray">
						<div class="test_screen_l f16px"><span class="inline">类型</span><i class="inline">：</i></div>
						<div class="test_screen_r tc">
							<span class="test_screen_list bg_gray" v-for="(item,index) in type" :key="index" :class="{'on':item==type_cur}" @click="typeCheck(item)">{{item}}</span>
						</div>
					</div>
				</div>
				<div class="f18px cl_gray mat30">共 <span class="cl_yel">{{total}}</span> 套试卷</div>
				<div class="task_paper_cont mat20">
					<div class="task_paper_list flex radius8 bs mab30" v-for="(item,index) in list" :key="index">
						<div class="task_paper_list_l">
							<router-link :to="{ path: '/paper_details', query: { id: item.id}}" class="f20px cl_dark inline clip">{{item.paperName}}</router-link>
							<p class="cl_gray mat10">题目数量：{{item.number}}</p>
						</div>
						<div class="task_video_list_item_btn cur tc cl_white on" v-if="item.is_exist == 1" @click="remove(index)">-移出作业篮</div>
						<div class="task_video_list_item_btn cur tc cl_white" v-else @click="join(index)">+加入作业篮</div>
					</div>
				</div>
				<div class="famous_page flex" v-if="list.length > 0">
					<div class="famous_page_l f16px cl_gray"> </div>
					<div class="famous_page_r cl_dark">
						<el-pagination background layout="prev, pager, next, jumper"
						@current-change="handleCurrentChange" :page-size="pageSize" :current-page="currentPage" :total="total"></el-pagination>
					</div>
				</div>
				<div class="choice_empty tc f18px cl_gray" v-if="list.length == 0">
					<p>找不到内容，请重新选择</p>
				</div>
			</div>
		</div>
		<!-- 作业篮 -->
		<router-link to="/basket" class="basket">
			<el-popover placement="bottom-start" trigger="hover">
				<div class="basket_hide" v-if="basket.subject_data.length > 0">
					<table class="basket_hide_cont f16px">
						<tr class="basket_hide_item cl_dark">
							<td align="center">学科</td>
							<td align="center">视频</td>
							<td align="center">试卷</td>
						</tr>
						<tr class="basket_hide_item cl_gray" v-for="(item,index) in basket.subject_data" :key="index">
							<td align="center">{{item.subjectName}}</td>
							<td align="center">{{item.video_num == null || item.video_num == "" || item.video_num == 0 ? "-" : item.video_num}}</td>
							<td align="center">{{item.shijuan_num == null || item.shijuan_num == "" || item.shijuan_num == 0 ? "-" : item.shijuan_num}}</td>
						</tr>
					</table>
					<div class="tc mat10">
						<router-link to="/basket" class="cl_blue">预览预选作业 ></router-link>
					</div>
				</div>
				<el-button slot="reference" class="basket_link">
					<img src="../../../static/basket_icon.png" />
					<div class="basket_link_text cl_white">
						<p class="f20px">作业篮</p>
						<p class="f16px mat5"><span class="cl_yel">{{basket.count}}</span>项内容</p>
					</div>
				</el-button>
			</el-popover>
		</router-link>
	</div>
</template>

<script>
	import teacherHeader from '../../components/teacher_header.vue'
	
	export default {
		name: 'task_paper',
		components: {
			teacherHeader,
		},
		props: {
			
		},
		data () {
			return {
				myInfo: {},
				public: {},
				logo_name: "学科作业资源库",
				nav: [
					{
						id: 1,
						name: "视频作业",
						url: "/task_video",
					},{
						id: 2,
						name: "试卷作业",
						url: "/task_paper",
					},{
						id: 3,
						name: "习题作业",
						url: "/task_topic",
					},
				],
				nav_cur: 2,
				subject: [], //学科
				subject_cur: "",
				grade: [], //年级
				grade_cur: "",
				type: [], //类型
				type_cur: "",
				list: [],
				currentPage: 1, //当前页数
				pageSize: 20, //每页数量
				total: 0, //总页数
				basket: {
					count: 0,
					subject_data: [],
				}, //作业篮
				
			}
		},
		created() {
			
		},
		mounted() {
			this.getSubject();
			this.getBasket();
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			//学科
			getSubject () {
				this.$get("/api/material/get_subject_data",{})
				.then(res => {
					this.subject = res.data;
					this.subject_cur = this.subject[0].subjectName;
					this.getGrade();
				});
			},
			//年级
			getGrade () {
				this.$get("/api/funlearning/get_grade_data",{})
				.then(res => {
					this.grade = res.data;
					this.grade_cur = this.grade[0];
					this.getType();
				});
			},
			//类型
			getType () {
				this.$get("/api/funlearning/get_paper_type_data",{})
				.then(res => {
					this.type = res.data;
					this.type.unshift("全部");
					this.type_cur = this.type[0];
					this.getList();
				});
			},
			//试卷
			getList () {
				var type = "";
				if (this.type_cur == "全部") {
					type = "";
				} else {
					type = this.type_cur;
				}
				this.$get("/api/teacher/get_papers_work_list",{
					token: localStorage.getItem("token"),
					subject_name: this.subject_cur,
					grade_name: this.grade_cur,
					paper_type: type,
					page: this.currentPage,
					limit: this.pageSize,
				})
				.then(res => {
					this.list = res.data.data;
					this.total = res.data.total;
				});
			},
			subjectCheck (e) {
				this.subject_cur = e;
				this.currentPage = 1;
				this.getList();
			},
			gradeCheck (e) {
				this.grade_cur = e;
				this.currentPage = 1;
				this.getList();
			},
			typeCheck (e) {
				this.type_cur = e;
				this.currentPage = 1;
				this.getList();
			},
			//加入
			join (e) {
				var item_ids = this.list[e].id;
				this.$get("/api/teacher/post_join_basket",{
					token: localStorage.getItem("token"),
					item_type: "papers", //video视频,test组卷,papers试卷,exam校本试卷
					item_ids: item_ids,
					pack_id: "",
				})
				.then(res => {
					this.list[e].is_exist = 1;
					this.$message({
						type: 'success',
						message: res.msg,
						duration: 1500,
					});
					this.getBasket();
				});
			},
			//移除
			remove (e) {
				var item_ids = this.list[e].id;
				this.$get("/api/teacher/post_remove_basket",{
					token: localStorage.getItem("token"),
					item_type: "papers", //video视频,test组卷,papers试卷,exam校本试卷
					item_ids: item_ids,
					pack_id: "",
				})
				.then(res => {
					this.list[e].is_exist = 0;
					this.$message({
						type: 'success',
						message: res.msg,
						duration: 1500,
					});
					this.getBasket();
				});
			},
			getBasket () {
				this.$get("/api/teacher/get_basket_statistics_message",{
					token: localStorage.getItem("token"),
				})
				.then(res => {
					this.basket = res.data;
				});
			},
			handleCurrentChange: function(currentPage){
				this.currentPage = currentPage;
				this.getList();
			},
		},
	}
</script>

<style>
</style>
